import Add16 from '@carbon/icons-react/es/add/16';
import {
  faHandshakeAlt,
  faTelescope,
} from '@fortawesome/pro-duotone-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { Button } from 'components/atoms/button';
import { EmptyState, EmptyStateContainer } from 'components/atoms/empty-state';

const StyledFontAwesomeIcon = styled(FontAwesomeIcon)`
  color: var(--gray-30);
`;

export const PartnerListEmptyState: FC<{ onClick: () => void }> = ({
  onClick,
}) => {
  return (
    <EmptyStateContainer>
      <EmptyState
        image={<StyledFontAwesomeIcon icon={faHandshakeAlt} size="4x" />}
        title={<FormattedMessage id="partners.list.empty.title" />}
        message={<FormattedMessage id="partners.list.empty.description" />}
        primaryCTA={
          <Button
            type="primary"
            iconPlacement="right"
            icon={<Add16 />}
            onClick={onClick}
          >
            <FormattedMessage id="partners.add" />
          </Button>
        }
      />
    </EmptyStateContainer>
  );
};

export const PartnerListNoSearchResultState: FC = () => (
  <EmptyState
    image={<StyledFontAwesomeIcon icon={faTelescope} size="4x" />}
    title={<FormattedMessage id="partners.list.empty.no_search_result.title" />}
    message={
      <FormattedMessage id="partners.list.empty.no_search_result.description" />
    }
  />
);
